import React, { createContext, useContext, useEffect, useState } from "react";
import { setVisualMode } from "../utils/visualMode";

const VisualModeContext = createContext({
  mode: "full",
  isMinimal: false,
  setMode: () => {},
});

function getInitialVisualMode() {
  try {
    if (typeof localStorage === "undefined") return "full";
    const saved = localStorage.getItem("bbx:visual-mode");
    return saved === "minimal" ? "minimal" : "full";
  } catch {
    return "full";
  }
}

export function VisualModeProvider({ children }) {
  const [mode, setModeState] = useState(() => getInitialVisualMode());

  useEffect(() => {
    // Varmistaa, että html/body saa oikean luokan heti ensimmäisen renderin jälkeen.
    // State on jo alustettu localStoragesta, joten tässä ei synny full -> minimal -välähdystä.
    setVisualMode(mode);
  }, [mode]);

  useEffect(() => {
    // Synkkaa, jos toinen välilehti vaihtaa tilaa.
    const onStorage = (e) => {
      if (e.key !== "bbx:visual-mode") return;
      setModeState(e.newValue === "minimal" ? "minimal" : "full");
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const setMode = (next) => {
    const normalized = next === "minimal" ? "minimal" : "full";
    setModeState(normalized);
    setVisualMode(normalized);
  };

  return (
    <VisualModeContext.Provider
      value={{ mode, isMinimal: mode === "minimal", setMode }}
    >
      {children}
    </VisualModeContext.Provider>
  );
}

export function useVisualMode() {
  return useContext(VisualModeContext);
}
